import { IFilterComponent, SearchFilter } from '../../../../infrastructure/iFilter-component';
import { OnInit, Component, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FilterService } from '../../../../services/filter.service';
import { AuthService } from '../../../../services/auth.service';
import { FilterRecordService } from '../../../../services/filter-record.service';
import { LogisticsService } from '../../../../services/logistics.service';

@Component({
  selector: 'app-receive-study-report-logistics-filter',
  templateUrl: './receive-study-report-logistics-filter.component.html',
})
export class ReceiveStudyReportLogisticsFilterComponent implements IFilterComponent, OnInit {

  form: FormGroup;
  @ViewChild('formElement', {static: false}) formElement: ElementRef;

  constructor(private formBuilder: FormBuilder
    , private filterService: FilterService
    , private authService: AuthService
    , private logisticsService: LogisticsService
    , private filterRecordService: FilterRecordService) {

    this.form = this.formBuilder.group({
      Name: [''],
      ShowReceive: [false],
    });
  }

  get f() { return this.form.controls; }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  async saveFilters() {
    this.filterRecordService.saveFilters('ReceiveStudyReportLogisticsFilterComponent', this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters('ReceiveStudyReportLogisticsFilterComponent', this.form);
  }

  async search(): Promise<any> {
    return await this.logisticsService.getStudyReportBatchesToReceive(
      <boolean>this.form.controls.ShowReceive.value
      , this.form.controls.Name.value
      , null
      , this.authService.getSectorId());
  }

  async ngOnInit() {

  }
}
